import { render, staticRenderFns } from "./ProductDownload.vue?vue&type=template&id=3c550875&scoped=true&"
import script from "./ProductDownload.vue?vue&type=script&lang=js&"
export * from "./ProductDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c550875",
  null
  
)

export default component.exports